import Carousel from "react-bootstrap/Carousel";
import React from "react";
import slide1 from "../Images/slide1.png";
import slide2 from "../Images/slide2.png";
import slide3 from "../Images/slide3.png";
import slide4 from "../Images/slide4.png";
import slide5 from "../Images/slide5.png";

const style = {
  height: "100vh",
};

function Slider() {
  return (
    <div style={{ position: "absolute", top: 0 }}>
      <Carousel className="carousel">
        <Carousel.Item className="bannerContainer">
          <img
            className="d-block w-100"
            src={slide1}
            style={style}
            alt="First slide"
          />
          {/* <ReactPlayer
          
            playing={true}
            muted
            controls={false}
            loop={true}
            url="video1.mp4"
            height="100%"
            width="100%"
          /> */}
        </Carousel.Item>
        <Carousel.Item>
          <img
            className="d-block w-100"
            src={slide2}
            style={style}
            alt="Second slide"
          />
        </Carousel.Item>
        <Carousel.Item>
          <img
            className="d-block w-100"
            src={slide3}
            style={style}
            alt="Second slide"
          />
        </Carousel.Item>
        <Carousel.Item>
          <img
            className="d-block w-100"
            src={slide4}
            style={style}
            alt="Second slide"
          />
        </Carousel.Item>
        <Carousel.Item>
          <img
            className="d-block w-100"
            src={slide5}
            style={style}
            alt="Second slide"
          />
        </Carousel.Item>
      </Carousel>
    </div>
  );
}

export default Slider;
